/**
 * Longueurs maximales par réseau, reprises du référentiel `networks`
 * (migration 001). Dupliquées ici parce que la réglette d'occupation doit
 * s'afficher sans attendre un appel serveur — un test côté API vérifie déjà
 * que ces valeurs ne divergent pas de la migration.
 */
export const LIMITES_RESEAU: Readonly<Record<string, number>> = {
  instagram: 2200,
  facebook: 63206,
  linkedin: 3000,
  gbp: 1500,
};

export const LIBELLES_RESEAU: Readonly<Record<string, string>> = {
  instagram: 'Instagram',
  facebook: 'Facebook',
  linkedin: 'LinkedIn',
  gbp: 'Google Business',
};

/** Part de la limite consommée, bornée à 1 pour que la réglette ne déborde jamais. */
export function tauxOccupation(network: string, longueur: number): number {
  const limite = LIMITES_RESEAU[network];
  if (!limite) return 0;
  return Math.min(1, longueur / limite);
}

/**
 * Au-delà de 85 % le texte risque d'être coupé à la publication : c'est le
 * seul moment où la réglette change de couleur, pour que le rouille garde son
 * sens d'avertissement.
 */
export function seuilOccupation(taux: number): 'normal' | 'haut' {
  return taux >= 0.85 ? 'haut' : 'normal';
}

/**
 * « 762 / 3 000 » plutôt que « 762 car. » : sans la limite affichée, la
 * réglette n'a aucune légende et un nombre seul ne dit pas s'il est
 * confortable ou limite.
 */
export function formatOccupation(network: string, longueur: number): string {
  const limite = LIMITES_RESEAU[network];
  const compte = longueur.toLocaleString('fr-FR');
  return limite ? `${compte} / ${limite.toLocaleString('fr-FR')}` : `${compte} car.`;
}
